import * as React from 'react';
import {AssetSearchRequest, AssetSearchResponse} from "../../api";
import iconLeft from "../../assets/icons/arrow-left.svg";
import iconRight from "../../assets/icons/arrow-right.svg";
import {useSearchParams} from "react-router-dom";

interface IAssetResultContainerPagination {
    result: AssetSearchResponse;
    request: AssetSearchRequest;
}

export const AssetResultContainerPagination: React.FC<IAssetResultContainerPagination> = ({result}) => {

    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams({
        page: "0"
    });

    const nextPage = () => {
        setSearchParams(params => {
            params.set("page", (result.request.page + 1).toString());
            return params;
        });
    };

    const previousPage = () => {
        setSearchParams(params => {
            params.set("page", (result.request.page - 1).toString());
            return params;
        });
    };

    const renderPagination = () => {
        if (result.count === 0 || result.maxPages === 1) {
            return "";
        }
        let maxPage = result.maxPages || 0;
        let currentPage = result.request.page;

        return (
            <>
                {currentPage !== 0 ?
                    <div className="btn mr-2"><img className="icon icon-lg" onClick={previousPage} src={iconLeft}
                                                   title="previous page" alt="previous"/></div> : ""}
                <div>Pages {result.request.page + 1}/{maxPage + 1} ({result.count} Items found)</div>
                {result.request.page < maxPage ?
                    <div className="btn ml-2"><img className="icon icon-lg" onClick={nextPage} src={iconRight}
                                                   title="next page" alt="next"/></div> : ""}
            </>);
    };

    return (
        <section className="w-100 d-flex align-items-center justify-content-center pagination">
            {renderPagination()}
        </section>
    );
};

export default AssetResultContainerPagination;
